$(function () {
    $('[data-refresh]').each(function () {
        var self = $(this);
        var interval = self.data('refresh-interval');
        if (!interval) {
            interval = 3;
        }
        setInterval( function () {
            $.getJSON(self.data('refresh'), function (res) {
                if (res.redirect) {
                    window.location = res.redirect;
                } else if (res.content) {
                    self.html(res.content);
                }
            });
        },interval * 1000);
    });
})
